import React, { Component } from "react";
import ErrorString from './error_string';

class Tel extends Component
{
    constructor(props) {
        super(props);

        this.handleCurrencyKeyPress = this.handleCurrencyKeyPress.bind(this);
    }

    handleCurrencyKeyPress(event)
    {
        event = event || window.event;
        var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
        var charStr = String.fromCharCode(charCode);

        if (!/\d/.test(charStr)) {
            event.preventDefault();
            return;
        }
    }

    render()
    {
        const {
            className,
            error,
            id,
            name,
            onChange,
            placeholder,
            required,
            value
        } = this.props

        return (
            <>
                <input
                    className={ "block w-full bg-white border-grey-2 rounded-sm focus:border-bb focus:ring-bb" + (className ? " " + className : "") }
                    id={ id }
                    name={ name }
                    value={ value }
                    onChange={ onChange }
                    onKeyPress={ this.handleCurrencyKeyPress }
                    placeholder={ placeholder }
                    required={ required }
                    type="tel"
                />
                <ErrorString error={ error } />
            </>
        );
    }
}

export default Tel;